module.exports = __webpack_public_path__ + "static/media/wallets@2x.be12df89.png";